"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";

export default function NotFound() {
 const router = useRouter();

 return (
 <div className="min-h-screen flex items-center justify-center bg-muted px-4">
 <div className="text-center max-w-lg">
 <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-8">
 <span className="text-5xl font-bold text-blue-600">404</span>
 </div>
 <h1 className="text-3xl font-bold text-foreground mb-4">Page Not Found</h1>
 <p className="text-muted-foreground mb-8">
 Sorry, the page you are looking for doesn&apos;t exist or has been moved.
 </p>
 <div className="flex items-center justify-center gap-4">
 <button
 onClick={() => router.back()}
 className="px-6 py-3 bg-muted text-foreground/80 rounded-xl font-medium hover:bg-muted transition-colors"
 >
 Go Back
 </button>
 <Link
 href="/"
 className="px-6 py-3 bg-gradient-to-r from-blue-600 to-violet-600 text-white rounded-xl font-medium hover:opacity-90 transition-opacity"
 >
 Home Page
 </Link>
 </div>
 </div>
 </div>
 );
}
